import React from 'react'
import BoxCard from '../../BoxPage/BoxCard'
import AppointmentCard from '../../Appointment/AppointmentCard'
import UserCard from '../../User/UserCard'
import { Image } from 'antd'

export default function CollapseContent ({ box, appointment, date, isNow, siderDisabled }) {
  return (
    <div style={{ gap: '1em', display: 'flex', flexDirection: 'column' }}>
      <div
        className='appointmentPageContainer'
        style={{
          gap: '1em',
          flex: 1,
          display: 'flex',
          flexDirection: 'horizontal',
          position: 'relative'
        }}>
        <div className="cards" style={{ gap: '1em', display: 'flex', flexDirection: 'column' }}>
          {box && <BoxCard box={box} disabled={siderDisabled} />}
          {date && <AppointmentCard date={date} isNow={isNow} box={box} disabled={siderDisabled} />}
          {appointment && <UserCard appointment={appointment} />}
        </div>
      </div>
      {
        box && box.waiting_time_url &&
        <Image
          width={'30em'}
          src={box.waiting_time_url.url}
        />
      }
    </div>
  )
}
